module.exports = __webpack_public_path__ + "static/media/1024096.82297801.png";